import {
    AmplitudeEvents as AmplitudeEventsCommon,
    AmplitudeProperties as AmplitudePropertiesCommon,
} from '@packlink/metrics';

enum AmplitudeCustomEvents {
    PRINT_LABEL_IN_BULK = 'Print label in bulk',
    PRINT_PACKING_SLIP = 'Click Print Packing Slip',
    PICK_UP_ORDER_IMPORTED = 'Pick up order imported',
    CLICK_CHECK_CARRIERS_POLICIES = 'Click check and accept the Terms and Conditions of the transport agency',
    CLICK_UNCHECK_CARRIERS_POLICIES = 'Click uncheck the Terms and Conditions of the transport agency',
    CLICK_CUSTOMER_SERVICE_HEADER = 'Click on Customer Service (header)',
    CLICK_EDIT_SEND_TO = 'Click on Edit on: Send to section',
    CLICK_EDIT_SEND_FROM = 'Click on Edit on Send from/Return to section',
    CLICK_DROP_OFF_CHIP = 'Click Drop off chip',
    CLICK_COLLECTION_CHIP = 'Click Collection chip',
    CLICK_CLOSE_CHANGE_ADDRESS = 'Click on Close Change Address',
    CLICK_SAVE_CHANGE_ADDRESS = 'Click on Save Change Address',
    CLICK_EXIT_CHANGE_ADDRESS = 'Click on exit Change Address',
    CLICK_CHANGE_FORMAT = 'Click Change format',
    CLICK_OPEN_PACKING_SLIP = ' Click open packing slip',
    CLICK_EXIT_LABEL_PRINTING_PREFERENCE = 'Click exit label printing preference',
    CLICK_4X6_LABEL = 'Click 4x6 label printing preference',
    CLICK_A4_LABEL = 'Click A4 label printing',
    CLICK_SAVE_LABEL_PRINTING = 'Click Save label printing',
    CLICK_CLOSE_LABEL_PRINTING_PREFERENCE = 'Click Close label Printing preference',
    CLICK_SEE_MY_INVOICES = 'Click see my invoices',
    CLICK_MODIFY_MY_INVOICES = 'Click modify my invoices',
    CLICK_FOLLOW_OUR_GUIDE = 'Click follow our guide',
    CLICK_BACK_TO_SOLD_ITEMS = 'Click go back to your sold items',
    CLICK_CONTACT_US = 'Click Contact Us',
    CLICK_CANCEL_SHIPMENT = 'Click Cancel shipment',
    CLICK_CANCEL_AND_PURCHASE_NEW_LABEL = 'Click Cancel and purchase new label',
    CLICK_EXIT_INVOICE_FORM = 'Click exit invoice form',
    CLICK_TOP_I_DONT_NEED_A_VAT_INVOICE = 'Click TOP I don´t need a VAT invoice',
    CLICK_SAVE_INVOICE_INFO = 'Click save invoice info',
    CLICK_BOTTOM_I_DONT_NEED_A_VAT_INVOICE = 'Click BOTTOM I don´t need a VAT invoice',
    CLICK_EXIT_TO_PURCHASE_NEW_LABEL = 'Click exit to purchase new label',
    CLICK_NO_TO_CANCEL_LABEL = 'Click No to Cancel Label',
    CLICK_YES_TO_PURCHASE_NEW_LABEL = 'Click yes purchase new label',
    CLICK_CONFIRM_AND_PAY = 'Click Confirm and Pay',
    CLICK_ON_PAY = 'Click on pay',
    CLICK_ON_GET_LABEL = 'Click on get Label',
    CLICK_ON_SINGLE_FLOW_MULTILABEL_BUTTON = 'Click SingleFlow Multilabel button',
    CLICK_ON_DO_YOU_HAVE_A_PROMO_CODE = 'Click on Do you have a promo code?',
    CLICK_ON_SERVICE = 'Clicked on service from service list with ordinal:',
    CLICK_ON_COMPENSATION = 'Click on Compensation level of type:',
    CLICK_ON_PRINT_IN_STORE = 'Clicked on print in store',
    CLICK_ON_REQUIRE_ADULT_SIGNATURE = 'Clicked on require adult signature',
    CLICK_ON_OTHER_CHIP = 'Click on OTHER chip',
    CLICK_ON_FIND_CLOSEST_LOCKER = 'Click on "find your closest" scroll down link',
    SCROLL_DOWN_AFTER_CLICK_ON_CONFIRM_AND_PAY = 'Scroll down after clicking on pay',
}

export enum AmplitudeCustomProperties {
    OPEN_OR_DOWNLOAD = 'Open or download',
    SERVICE_NAME = 'Service name',
}

export enum AmplitudePropertiesValues {
    PAYPAL = 'PayPal',
    CREDIT_CARD = 'Credit Card',
    DEFERRED = 'Deferred',
    DOWNLOAD_LABEL = 'Download',
    OPEN_LABEL = 'Open',
    FREE = 'Free',
}

export type AmplitudeEvents = AmplitudeEventsCommon | AmplitudeCustomEvents;
export const AmplitudeEvents = { ...AmplitudeEventsCommon, ...AmplitudeCustomEvents };

export type AmplitudeProperties = AmplitudePropertiesCommon | AmplitudeCustomProperties;
export const AmplitudeProperties = { ...AmplitudePropertiesCommon, ...AmplitudeCustomProperties };
